import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import { createRoot } from "react-dom/client";
import App from "./App";
import store from "./store";
import history from "./history";
createRoot(document.getElementById("root")).render(
  <Provider store={store}>
    <Router history={history}>
      <App />
    </Router>
  </Provider>
);
